<template>
  <div v-show="mostrarmodal"  >
    <div id="modalDetalle" class="modal">
      <div class="modal-contenido rounded-xl p-1">
        <div class="grid grid-cols-6 justify-items-end">
          <button
            @click="clean()"
            type="button"
            class="col-start-6 end text-xl mx-2 p-1"
          >
            <a class="font-bold" href="#">X</a>
          </button>
        </div>
        <div class="w-full">
          <h4
            class="
              bg-gray-100
              mx-9
              mb-1
              text-2xl
              shadow-xl
              text-black text-center
              mt-1
              rounded
              divide-y divide-red-500
            "
          >
            Detalle Pedido
            <hr color="black" size="4" />
          </h4>
        </div>
        <!--<div
          class="border rounded-xl w-80 border-solid border-t-4 border-l-4 border-r-4 border- shadow-2xl"
        >-->
        <div>
          <table class="min-w-full uppercase bg-white">
            <thead class="bg-blue-800 text-white">
              <tr>
                <th class="text-left px-4 uppercase font-semibold text-sm">
                  Cantidad
                </th>
                <th class="px-4 uppercase font-semibold text-sm">
                  Codigo Producto
                </th>
                <th class="px-4 uppercase font-semibold text-sm">Descuento</th>
                <th class="px-4 uppercase font-semibold text-sm">Iva</th>
                <th class="px-4 uppercase font-semibold text-sm">
                  Precio Pedido
                </th>
                <th class="px-4 uppercase font-semibold text-sm">
                  Valor Cliente
                </th>
              </tr>
            </thead>
            <tbody class="text-gray-700 divide-y-2 border rounded">
              <tr
                class="bg-gray-100 border border-gray-200 hover:bg-white     divide
                divide-x
                divide-gray-300"
                :key="api.iddetalle"
                v-for="api in detalle"
              >
                <td class="text-center px-4">
                  {{ api.cantidadpedido }}
                </td>
                <td class="text-center">
                  {{ api.codigoproductopedido }}
                </td>
                <td class="text-center">
                  {{ api.descuento }}
                </td>
                <td class="text-center">
                  {{ api.iva }}
                </td>
                <td class="text-center">
                  {{ api.preciopedido }}
                </td>
                <td class="text-center">
                  {{ api.valorcliente }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
//import axios from "axios";
export default {
  name: "modalDetalle",
  data() {
    return {
      caracteristica: "",
      respuesta: null,
      idlinea: "",
      nombrelinea: "",
      value: null,
      descripcion: "",
      valor: false,
    };
  },


  methods: {
    ...mapMutations("pedidos", ["agregartable", "cargardatospedido", "cambio"]),

    /* async recargar() {
      setTimeout(() => {
        this.cargardatospedidos();
      }, 500);
    },*/

    mostrar() {
      this.cambio(this.descripcion);
      
    },
    mostrarinicial() {
      this.descripcion = this.descripcionmodal;
      this.valor = true;
      
    },

    clean() {
      this.descripcion = null;
      this.valor = false;
    },
  },
  computed: {
    ...mapState("pedidos", [
      "idmodal",
      "detalle",
      "mostrarmodal",
      "descripcionmodal",
    ]),
    ...mapState([
      "elemento",
      "id",
      //"descripcion",
      "numero",
      // "idmodal",
      //"descripcionmodal",
      "banderamodal",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 80%;
  height: auto;

  margin: auto;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
  
}
#modalDetalle:target {
  opacity: 1;
  pointer-events: auto;
}
</style>

